import React from "react";

import { pageRanges } from "../documentUtils";

export default function DocumentContents({ pages = [], labels }) {
  if (!pages.length) return null;
  const groups = new Map();
  pages.forEach(({ kind, page }) =>
    groups.set(kind, [...(groups.get(kind) || []), page]),
  );
  return (
    <details className="premium-document-contents">
      <summary>Zawartość pliku</summary>
      <p>System rozpoznał w tym pliku następujące dokumenty:</p>
      <ul>
        {[...groups].map(([kind, numbers]) => (
          <li key={kind}>
            {labels[kind] || "Inny dokument"}:{" "}
            {new Set(numbers).size === 1 ? "strona" : "strony"}{" "}
            {pageRanges(numbers)}
          </li>
        ))}
      </ul>
    </details>
  );
}
